import { DatePickerGrid } from '../DatePickerGrid';
import { DatePickerHeader } from '../DatePickerHeader';
import { DatePickerContentProps } from './DatePickerContent.types';

/**
 * DatePickerContent - Composite component combining header and grid for date selection
 *
 * Renders the header with navigation and view controls, and the grid with selectable dates/months/years.
 *
 * @component
 * @param {DatePickerContentProps} props - Component props
 * @returns {JSX.Element} Date picker content with header and grid
 *
 * @example
 * <DatePickerContent
 *   view="day"
 *   displayDate={new Date()}
 *   value={selectedDate}
 *   onViewChange={setView}
 *   onNavigate={handleNav}
 *   onDayClick={handleDay}
 *   onMonthClick={handleMonth}
 *   onYearClick={handleYear}
 *   showTimeButton={true}
 * />
 */
export const DatePickerContent = ({
  view,
  displayDate,
  value,
  onViewChange,
  onNavigate,
  onDayClick,
  onMonthClick,
  onYearClick,
  showTimeButton = false
}: DatePickerContentProps) => {
  return (
    <>
      <DatePickerHeader
        view={view}
        displayDate={displayDate}
        onViewChange={onViewChange}
        onNavigate={onNavigate}
        showTimeButton={showTimeButton}
      />
      {view !== 'time' && (
        <DatePickerGrid
          view={view}
          displayDate={displayDate}
          value={value}
          onDayClick={onDayClick}
          onMonthClick={onMonthClick}
          onYearClick={onYearClick}
        />
      )}
    </>
  );
};
